import { render, staticRenderFns } from "./KanbanCardItem.vue?vue&type=template&id=009952d9&scoped=true&"
import script from "./KanbanCardItem.vue?vue&type=script&lang=js&"
export * from "./KanbanCardItem.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCardItem.vue?vue&type=style&index=0&id=009952d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009952d9",
  null
  
)

export default component.exports